import { useSelector } from '@betty/toolkit/state';
import {
  selectPromotedContentDataState,
  selectPromotedGameIds,
  selectPromotedSubproviderIds,
} from '../state';
import { useMemo } from 'react';

const usePromotedContent = () => {
  const gameIds = useSelector(selectPromotedGameIds);
  const subproviderIds = useSelector(selectPromotedSubproviderIds);
  const dataState = useSelector(selectPromotedContentDataState);

  return useMemo(
    () => ({
      gameIds,
      subproviderIds,
      isFetching: dataState === 'pending',
    }),
    [gameIds, subproviderIds, dataState],
  );
};

export default usePromotedContent;
